import { ModelBase, Property } from '@skylab-shared/core';
import { OrderPaymentType } from './common/order-payment-kind';

export class OrderPaymentSummary extends ModelBase {
	@Property()
	public totalAmount: number;

	@Property()
	public paidAmount: number;

	@Property()
	public pendingAmount: number;

	@Property()
	public isPaid: boolean;

	@Property()
	public paymentType: OrderPaymentType;
}
